import { Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RaIconComponent, RaShinyTextComponent, RaSkeletonComponent } from 'ra-ui';
import { EDIT_MODE_TRANSITION_MS, EditModeService } from '../../services/edit-mode.service';

/**
 * Overlay da troca de modo (docs/EDITOR-CHAT-IA.md, seção 2): cobre a área abaixo do
 * header com o orb da IA pulsando, o texto brilhante do destino, uma barra de 2 s e o
 * esqueleto do layout de destino atrás. Fica na tela enquanto
 * `EditModeService.switchingTo()` tem um destino, ou seja, 2 s ou até o modo carregar.
 *
 * Não bloqueia nada além do próprio editor: o header continua acima (z-index menor que o
 * dele), com voltar e menu funcionando.
 */
@Component({
    selector: 'edit-mode-transition',
    templateUrl: 'edit-mode-transition.component.html',
    styleUrl: 'edit-mode-transition.component.scss',
    imports: [RaIconComponent, RaShinyTextComponent, RaSkeletonComponent, TranslatePipe],
})
export class EditModeTransitionComponent {
    private _modeService = inject(EditModeService);

    public target = this._modeService.switchingTo;
    public durationMs = EDIT_MODE_TRANSITION_MS;

    public titleKey = computed(() =>
        this.target() === 'ai'
            ? 'document.edit.modeTransition.toAiTitle'
            : 'document.edit.modeTransition.toManualTitle'
    );

    public subtitleKey = computed(() =>
        this.target() === 'ai'
            ? 'document.edit.modeTransition.toAiSubtitle'
            : 'document.edit.modeTransition.toManualSubtitle'
    );
}
